import { forwardRef, Ref, SVGAttributes } from 'react';
import { Icon } from './BaseIcon';

export const Project = forwardRef(
  (props: SVGAttributes<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="71"
      fill="none"
      viewBox="0 0 64 71"
      ref={ref}
      {...props}
    >
      <path
        fill="#838495"
        fillRule="evenodd"
        d="M27.186 1.77a9.42 9.42 0 019.408.001l.006.004 22.47 12.84a9.42 9.42 0 014.71 8.148v25.686a9.42 9.42 0 01-4.71 8.148l-.012.007L36.6 69.437a9.42 9.42 0 01-9.42 0L4.722 56.604l-.012-.007A9.42 9.42 0 010 48.449V22.763a9.42 9.42 0 014.71-8.149l.012-.006L27.186 1.77zm4.704 4.743c-.6 0-1.19.158-1.71.458l-.012.006L7.71 19.811l-.005.002A3.42 3.42 0 006 22.767v25.677a3.42 3.42 0 001.705 2.954l.005.003 22.47 12.84a3.42 3.42 0 003.42 0l.011-.007L56.07 51.401l.005-.003a3.42 3.42 0 001.705-2.953V22.77v-.003a3.42 3.42 0 00-1.706-2.953l-.004-.002L33.6 6.97a3.42 3.42 0 00-1.71-.458z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#838495"
        fillRule="evenodd"
        d="M14.847 9.1a3 3 0 014.099-1.098l12.944 7.48 12.944-7.48a3 3 0 013.002 5.195L33.39 21.544a3 3 0 01-3.002 0l-14.445-8.347A3 3 0 0114.847 9.1zM.402 34.105a3 3 0 014.099-1.097l14.445 8.346a3 3 0 011.499 2.598v16.66a3 3 0 11-6 0V45.683l-12.946-7.48a3 3 0 01-1.097-4.098zM63.377 34.105a3 3 0 01-1.096 4.098l-12.946 7.48v14.929a3 3 0 01-6 0v-16.66a3 3 0 011.499-2.598l14.445-8.346a3 3 0 014.098 1.097z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#838495"
        fillRule="evenodd"
        d="M1.27 17.925a3 3 0 014.099-1.094l26.52 15.341 26.522-15.341a3 3 0 113.004 5.193l-28.023 16.21a3 3 0 01-3.004 0L2.365 22.025a3 3 0 01-1.095-4.099z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#838495"
        fillRule="evenodd"
        d="M31.89 32.606a3 3 0 013 3v32.357a3 3 0 01-6 0V35.606a3 3 0 013-3z"
        clipRule="evenodd"
      ></path>
    </Icon>
  ),
);
